<template>
  <div class="diseño_wrapper">
    <headView :option="title" :subtitleOpt="subtitleOpt"></headView>
    <div class="content-design">
      <div class="diseño_header">
        <p class="header_text">Diseño y Estética</p>
      </div>
      <div class="diseño_body">
        <div class="diseño_body__logo">
          <imageUploader text="Logo de la empresa" tipo="logo"/>
        </div>
        <div class="diseño_body__color-menu">
          <p class="colorPick_label">Elegir color de la cabecera del menú</p>
          <colorPicker colorprop="menu"/>
        </div>
        <div class="diseño_body__color-body">
          <p class="colorPick_label">Elegir color de la cabecera del body</p>
          <colorPicker colorprop="header"/>
        </div>
      </div>
    <div class="wrap-btn-content" v-if="roleEdit">
      <button class="button button-custom ripple btn-action wrap-btn-content--one"  @click="backToView">Cancelar</button>
      <button class="button button-custom ripple btn-action wrap-btn-content--two" @click="setDesign()">Guardar</button>
    </div>
    </div>
  </div>
</template>

<script>
import headView from "../Componentes/headView";
import colorPicker from "../Componentes/colorPicker";
import imageUploader from "../Componentes/imageUploader";
import { mapGetters } from "vuex";
import { service } from "@/helper/Rest";

export default {
  name: "DisenoView",
  components: {
    headView,
    colorPicker,
    imageUploader
  },
  data() {
    return {
      title: {
        headText: "Configuración",
        subtitle: ""
      },
      subtitleOpt: false,
      colorMenu: ""
    };
  },
  computed: {
    ...mapGetters(["headerColor", "menuColor", "roleEdit"])
  },
  beforeCreate() {
    this.$store.commit("setColorChildren", 'diseno')
  },
  beforeDestroy(){
    this.$store.commit("resetColorChildren", 'diseno')
  },
  created() {
    var colors = JSON.parse(this.$localStorage.get("colors"))
      ? JSON.parse(this.$localStorage.get("colors"))
      : "";
    if (colors) {
      this.$store.commit("changeColors", colors);
    }
  },
  methods: {
    backToView: function() {
      this.$router.push("edificios");
    },
    setDesign: function() {
      //confirmar el diseño de la vista del header y sidebar
      service
        .putCompany(this.$store.getters.company_id, {
          name: this.$store.getters.company.name,
          image: this.$store.getters.logo.file,
          hmenuColor: this.$store.getters.headerColor,
          hbodyColor: this.$store.getters.menuColor
        })
        .then(response => {
          this.success();
          this.$store.commit("changeColors", {
            hmenuColor: this.$store.getters.headerColor,
            hbodyColor: this.$store.getters.menuColor
          });
          var companyLocal = {
            hmenuColor: this.$store.getters.headerColor,
            hbodyColor: this.$store.getters.menuColor
          };

          this.$localStorage.set("colors", JSON.stringify(companyLocal));
        })
        .catch(err => console.warn(err));
    },
    success() {
      this.$toast.open({
        message: "Diseño aplicado",
        position: "is-bottom-right",
        type: "ffcolor-is-success"
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.content-design {
  /* margin-top: 70px; */
  max-width: 520px;
  padding-top: 70px;
  padding-left: 30px;
  padding-right: 30px;
}
.diseño_header {
  padding: 10px 0;
}
.diseño_body {
  &__logo {
    margin-bottom: 20px;
  }
  &__color-menu {
    margin-bottom: 20px;
  }
  &__color-body {
    margin-bottom: 20px;
  }
}
.colorPick_label {
  text-align: start;
  font-size: 16px;
}
.header_text {
  font-size: 25px;
  font-weight: bold;
  text-align: start;
  /* margin: 25px; */
}
.colorPick_label {
  margin: 0 0 10px !important;
}
.colorPicker {
  margin: 0 !important;
}
.imageUploader {
  margin: 0 !important;
  /* margin-left: 0 !important;
  margin-right: 0 !important; */
}
.imageUploader_done {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.wrap-btn-content {
  margin-top: 100px;
  padding: 10px 0;
  display: flex;
  flex-flow: row wrap;
  width: 460px;
  .btn-action {
    border-radius: 3px;
    width: 220px;
    // margin-left: 0;
    // margin-right: 0;
  }
  &--one {
    margin-left: 0;
    margin-right: 10px;
    background-color: #c8c8c8;
  }
  &--two {
    margin-right: 0;
    margin-left: 10px;
    background-color: #00c59a;
  }
}
.color_placeholder {
  height: 50px;
  width: 120px;
  border: 1px solid lightgrey;
  box-shadow: 0px 0px 0.5px 0px rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;
  margin: 10px 25px;
  font-size: 15px;
  p {
    padding: 10px 10px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/Main/DisenoView.vue